import React, { useContext, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { GlobalContex } from "../context/globalContext";

const Plans = () => {
  const {
    idFront,
    idBack,
    setIdFront,
    setIdBack,
    signature,
    setSignature,
  } = useContext(GlobalContex);

  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const sigPadRef = useRef(null);

  const handleFileChange = (e, setFile) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  const clearSignature = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
      setSignature(null);
    }
  };

  const saveSignature = () => {
    if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
      try {
        const trimmedCanvas = sigPadRef.current.getTrimmedCanvas();
        const dataUrl = trimmedCanvas.toDataURL("image/png");
        setSignature(dataUrl);
        setShowSignatureModal(false); // close modal after saving
      } catch (error) {
        console.error("Error saving signature:", error);
        alert("There was an issue saving your signature.");
      }
    } else {
      alert("Please provide a signature before saving.");
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4" style={{
      marginTop:"-10px"
    }}>
      <h1 className="text-primary-marineBlue font-bold text-[1.6rem] md:text-3xl leading-9">
      TATTOO & PIERCING WAIVER
      </h1>
      <div className="mt-8 space-y-6">
        {/* Front ID Upload */}
        <div>
          <label className="block font-medium text-primary-marineBlue mb-1">
            Front of ID
          </label>
          <p className="text-sm text-gray-500 mb-2">
            Upload a clear photo or scan of the <strong>front side</strong> of a valid government-issued ID (e.g., Driver’s License or Passport). Accepted formats: JPG, PNG.
          </p>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, setIdFront)}
            className="block w-full text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4
              file:rounded-lg file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
          />
          {idFront && (
            <p className="text-green-600 mt-1">Uploaded: {idFront.name}</p>
          )}
        </div>

        {/* Back ID Upload */}
        <div>
          <label className="block font-medium text-primary-marineBlue mb-1">
            Back of ID
          </label>
          <p className="text-sm text-gray-500 mb-2">
            Upload the <strong>back side</strong> of the same ID. Ensure text and barcodes are visible. Accepted formats: JPG, PNG.
          </p>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, setIdBack)}
            className="block w-full text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4
              file:rounded-lg file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
          />
          {idBack && (
            <p className="text-green-600 mt-1">Uploaded: {idBack.name}</p>
          )}
        </div>

        {/* Signature Button */}
        <div>
          <label className="block font-medium text-primary-marineBlue mb-1">
            Signature
          </label>
          <p className="text-sm text-gray-500 mb-2">
            Tap the button below to open the signature pad.
          </p>
          <button
            onClick={() => setShowSignatureModal(true)}
            className="px-4 py-2 bg-primary-marineBlue text-white rounded-md hover:bg-blue-800"
          >
            Sign Here
          </button>
          {signature && (
            <div className="mt-3">
              <p className="text-sm text-gray-600 mb-1">Signature Preview:</p>
              <img
                src={signature}
                alt="Signature Preview"
                className="w-48 border rounded"
              />
            </div>
          )}
        </div>
      </div>

      {/* Signature Modal */}
      {showSignatureModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-lg font-semibold text-primary-marineBlue mb-4">
              Draw Your Signature
            </h2>
            <SignatureCanvas
              ref={sigPadRef}
              penColor="black"
              canvasProps={{
                width: 400,
                height: 150,
                className: "border border-gray-400 rounded bg-white shadow",
              }}
            />
            <div className="flex justify-between items-center mt-4">
              <button
                onClick={clearSignature}
                className="text-red-600 underline"
              >
                Clear
              </button>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowSignatureModal(false)}
                  className="px-4 py-2 border border-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={saveSignature}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Save Signature
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Plans;
